import { Check, X } from "@phosphor-icons/react";

const ROWS = [
  "Stable temperature (2–8°C)",
  "Portable",
  "Battery powered",
  "Moisture controlled",
  "Travel friendly",
  "Designed for medication",
];

export default function Comparison() {
  return (
    <section
      data-testid="comparison"
      className="py-14 sm:py-20 bg-cool-white"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="overline text-cyan-brand">Head to head</div>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-[52px] font-bold text-navy-deep tracking-tight leading-[1.05] whitespace-nowrap">
            CryoVault vs a regular fridge.
          </h2>
        </div>

        <div className="mt-14 reveal rounded-3xl border border-[#8A97A8]/25 bg-white overflow-hidden max-w-5xl">
          <div className="grid grid-cols-[1.4fr_1fr_1fr]">
            <div className="p-5 sm:p-6 overline text-cool-grey border-b border-[#8A97A8]/20">
              Feature
            </div>
            <div className="p-5 sm:p-6 overline text-white bg-signature-gradient border-b border-teal-brand/30 flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-teal-brand" />
              CryoVault
            </div>
            <div className="p-5 sm:p-6 overline text-cool-grey border-b border-[#8A97A8]/20">
              Regular fridge
            </div>
          </div>

          {ROWS.map((row, i) => (
            <div
              key={row}
              data-testid={`comparison-row-${i}`}
              className={`grid grid-cols-[1.4fr_1fr_1fr] items-center ${
                i !== ROWS.length - 1 ? "border-b border-[#8A97A8]/15" : ""
              }`}
            >
              <div className="p-5 sm:p-6 text-navy-deep text-sm sm:text-[15px] font-medium">
                {row}
              </div>
              <div className="p-5 sm:p-6 bg-teal-brand/5 border-x border-teal-brand/15">
                <span className="h-9 w-9 rounded-full bg-cta-gradient text-white inline-flex items-center justify-center shadow-sm">
                  <Check size={16} weight="bold" />
                </span>
              </div>
              <div className="p-5 sm:p-6">
                <span className="h-9 w-9 rounded-full bg-cool-white text-cool-grey inline-flex items-center justify-center border border-[#8A97A8]/25">
                  <X size={14} weight="bold" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
